import {Kernel} from "inversify";

export const kernel = new Kernel();


// WEBPACK FOOTER //
// ./src/app/ioc/IOCHelper.ts